<template>
  <div>
    <span
      v-if="showTime"
    >
      {{ formatDateTime(date) }}
    </span>
    <span
      v-else-if="date"
    >
      {{ formatDate(date) }}
    </span>
    <span
      v-else
      class="text--disabled font-italic"
    >
      Not available
    </span>
  </div>
</template>

<script>

import { formatDate, formatDateTime } from '@/utils/dateFormats';


export default {
  name: 'DateDisplay',
  props: {
    date: {
      type: [String, Number],
      default: () => '',
    },
    showTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatDate,
      formatDateTime,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/DateDisplay.vue